import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { cn } from "@/lib/utils";
const categories = [{
  title: "Serramenti",
  description: "Profili minimali che incorniciano il paesaggio. Tecnologia e isolamento termico si fondono in un design essenziale per il massimo comfort abitativo.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/image_cdm9pv8e.png",
  alt: "Dettaglio macro di un serramento moderno con finitura premium"
}, {
  title: "Porte e Portoni",
  description: "Sicurezza e stile accolgono i tuoi ospiti. Materiali pregiati e meccaniche di precisione per ingressi che definiscono il carattere della tua casa.",
  image: "https://active-phoenix.10web.cloud/wp-content/uploads/2026/03/Schermata-2026-03-06-alle-17.38.27.png?v=ln9eft31alq",
  alt: "Texture ravvicinata di una porta di design con maniglia elegante"
}, {
  title: "Tende da Sole",
  description: "Ombra e luce in perfetta armonia. Tessuti tecnici innovativi e strutture discrete per vivere gli spazi esterni con eleganza e protezione.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/image_6u6zu9q7.jpg",
  alt: "Primo piano del tessuto di una tenda da sole di alta qualità"
}];
export default function EccellenzaNelDesignParte1() {
  return <section id="eccellenza-nel-design-parte-1" className="bg-white py-24 w-full overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-col gap-24 md:gap-32">
          {categories.map((category, index) => {
          const isEven = index % 2 !== 0;
          return <div key={index} data-index={index} className={cn("flex flex-col md:flex-row items-center gap-12 md:gap-20 lg:gap-24", isEven ? "md:flex-row-reverse" : "")}>
                {}
                <div className="w-full md:w-1/2">
                  <div className="w-full max-w-[600px] mx-auto md:max-w-none">
                    <AspectRatio ratio={1 / 1}>
                      <img src={category.image} alt={category.alt} className="h-full w-full object-cover rounded-2xl shadow-sm" />
                    </AspectRatio>
                  </div>
                </div>

                {}
                <div className="w-full md:w-1/2 flex flex-col justify-center text-center md:text-left">
                  <h3 className="text-3xl md:text-4xl font-bold text-[#576192] mb-10 tracking-tight">
                    {category.title}
                  </h3>
                  <p className="text-lg md:text-xl text-[#576192] font-normal leading-[1.6] max-w-lg mx-auto md:mx-0">
                    {category.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}